import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyBVJLtNxWKExomafyv86kANlbru2ejI4Ec",
    authDomain: "whatsup-ff287.firebaseapp.com",
    databaseURL: "https://whatsup-ff287.firebaseio.com",
    projectId: "whatsup-ff287",
    storageBucket: "whatsup-ff287.appspot.com",
    messagingSenderId: "899003811534",
    appId: "1:899003811534:web:b4d70a0beb151c47c8f29f"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

// explicit and implicit export
// basic export and default export (everytime)

export { auth, provider };
export default db;